import * as React from "react";
import styled from "styled-components";
import { PageContainer } from "../../../components";
import { DrupalBreedSearchBar } from "../breed/DrupalBreedSearchBar";
import { DrupalJudgelist } from "./DrupalJugelist";

export interface IDrupalJudgeListPageProps {}

const Container = styled.div``;

export const DrupalJudgeListPage: React.FunctionComponent<IDrupalJudgeListPageProps> = () => {
  const [breedId, setbreedId] = React.useState<number>(null);
  return (
    <PageContainer>
      <Container>
        <DrupalBreedSearchBar onSelectionChanged={(b: number) => setbreedId(b)} />
        <DrupalJudgelist breedId={breedId} />
      </Container>
    </PageContainer>
  );
};
